function escapeHtml(s) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function isHtml(s) {
  return /<\/?[a-z][\s\S]*?>/i.test(s);
}

function legacyToHtml(s) {
  const escaped = escapeHtml(s);
  const withMentions = escaped.replace(/@\[(\d+)\]\(([^)]+)\)/g, (_, id, name) =>
    `<span data-id="${id}" class="text-accent font-medium">@${name}</span>`
  );
  return withMentions.replace(/\n/g, '<br/>');
}

export default function CommentBody({ content }) {
  if (!content) return null;
  const html = isHtml(content) ? content : legacyToHtml(content);
  return (
    <div
      className="prose prose-sm max-w-none text-sm text-text-primary leading-relaxed break-words select-text [&_a]:underline [&_s]:line-through"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
